<template>
    <div style="min-width:800px;">



        <CompanyProfileModal
                v-if="showModal"
                @close="closeProfileModal"
                :company-profile-info="currProfileModalData"
        ></CompanyProfileModal>

        <div class="p-3 mb-5 text-center" v-if="currentPageSubmissionList.length==0">
            No data
        </div>


      <div class="">
        <b-row>
          <b-col cols="4">{{ $t("KYBApplicantName")}}</b-col>
          <b-col cols="2">{{ $t("CeoName")}}</b-col>
          <b-col>{{ $t("Country")}}</b-col>
          <b-col>
            {{ $t("Report/KybStatus")}}
          </b-col>
          <b-col>
            {{$t("FinalAMLResult")}}
          </b-col>
          <b-col cols="1" class="text-center">
            {{ $t("DetailInformation") }}
          </b-col>
        </b-row>
      </div>


      <div class="card my-3" v-for="item of currentPageSubmissionList" v-bind:key="item.submissionId">

        <div class="card-body mx-0 px-0 py-2 text-dark-50">
                <!--begin::Details-->
                <!--begin::Info-->
                <!--begin::Title-->
            <b-row>
              <b-col cols="4" class="">
                <div class="parent-box">
                  <div class="">
                    <span class="child-box font-size-h4 font-weight-bold ml-3 w-100 company-name-area">
                      {{item.companyName}}
                    </span>
<!--
                    <span class=" font-size-h6 font-weight-bold ml-3 w-100" style="">
                      {{'('+convertDateFormat($moment(item.updateTime).format('YYYY-MM-DD'))+')'}}
                    </span>
                    -->
                  </div>
                </div>
              </b-col>
              <b-col cols="2">
                <div class="w-100 parent-box">
                  <div class="child-box">
                    <b-icon-bookmark-fill></b-icon-bookmark-fill>
                    {{item.representative ? item.representative.ceoName : '-' }}
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="parent-box">
                  <span class="w-100 child-box" style="">
                    {{ item.country ? $store.getters.getCountryLabelByValue( item.country ) : '-' }}
                  </span>
                </div>
              </b-col>

              <b-col>
                <div class="d-inline">
                  <v-chip v-if="item.reportUrl" color="purple" text-color="white"
                          class=" m-1" @click="downloadFile(item.reportUrl)">
                    <span>{{ $t("KYBReport") }}</span>
                  </v-chip>
                  <v-chip v-if="!item.reportUrl" class="m-1">
                    <span>{{ $t("KYBReport") }}</span>
                  </v-chip>
                </div>

                <div class="d-inline">
                  <v-chip
                      class="m-1" :color="KYB_STATUS_COLOR[ item.kybStatus ]" text-color="white">
                    {{$t(KYB_PROJECT_STATUS_TEXT[item.kybStatus])}}
                  </v-chip>
                </div>

              </b-col>

<!--
              <b-col cols="1">
                <div v-if="item.aml_screen" class="parent-box">
                  <span class="child-box">
                    {{ item.aml_screen }}
                  </span>
                </div>
              </b-col>
-->



              <b-col>
                <div v-if="item.amlFinalStatus" class="parent-box text-start" style="">
                  <div class="child-box" style="">
                    <div>
                      {{ $t(item.amlFinalStatus) }}
                    </div>
                    <div v-if="item.amlFinalUpdateTime">
                      <small>
                        ({{ $moment( item.amlFinalUpdateTime ).format( "YYYY MMM DD" ) }})
                      </small>
                    </div>
                  </div>
                </div>
              </b-col>



              <b-col cols="1">
                <div class="my-lg-0 my-3 w-100 parent-box text-center">
                  <div class="child-box w-100">
                    <b-button class="" size="sm" variant="primary" @click="goDetail(item)">{{ $t("More") }}</b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
        </div>
                    <!--end::Info-->
                <!--end::Details-->
        </div>
        <!--end::Card-->

        <div class="my-10" v-if="currentPageSubmissionList.length>0">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center"></b-pagination>
        </div>
    </div>

</template>


<script>
import CompanyProfileModal from "@/view/components/modal/CompanyProfileModal";
export default {
  name: "SubmissionTable",

  components: {
      CompanyProfileModal,
  },
  computed: {

    KYB_PROJECT_STATUS_TEXT () {
      return this.$store.state.KYB_PROJECT_STATUS_TEXT;
    },
    KYB_STATUS_COLOR () {
      return this.$store.state.KYB_STATUS_COLOR;
    },
    rows() {
      return this.submissions.length
    },
    currentPageSubmissionList() {

      if( this.submissions.length == 0 ) {
        return [];
      }

      /** index와 order 차이는 index는 0부터 시작, order은 1부터 시작 */
      let startIndex = ( this.currentPage - 1 ) * this.perPage;
      let lastOrder = this.currentPage * this.perPage;


      return this.submissions?.slice(startIndex, lastOrder).map((item) => {
        if (item.amlFinalStatus && item.amlFinalStatus === 'Not Screened') {
          const changeAmlFinalStatus = item.amlFinalStatus.replace("Not Screened", "No Matches")
          return {
            ...item,
            amlFinalStatus: changeAmlFinalStatus
          }
        } else if (!item.amlFinalStatus) {
          return {
            ...item,
            amlFinalStatus: "N/A"
          }
        } else {
          return item
        }
      })
    }
  },
  data() {
      return {

        showModal: false,   //company profile modal show, hide

        /** page 관련 data start */
        perPage: 10,
        currentPage: 1,
        /** page 관련 data end */

        currProfileModalData : {},
      }
  },
  props: {
      submissions: Array
  },
  methods: {
      downloadFile(url){
        if(url) this.$store.dispatch('downloadFile', {url: url});
      },
      //  return 반올림 퍼센트
      mathRound( approvedCount, totalCount ) {
          if( !approvedCount || !totalCount ) {
              return 0;
          }
          if( approvedCount == 0 || totalCount == 0 ) {
              return 0;
          }
          return ((approvedCount/totalCount) * 100).toFixed(0)
      },
      goDetail( item ) {

          let name = "kyb-detail";
          let params = item;
          if(( this.$router.history.current.fullPath ).includes( "console" )){
              name = "console-submission-detail";
          }

          this.$store.dispatch('setSubmissionDirectors', item.directors);
          this.$store.dispatch('setSubmissionId', item.submissionId);
          this.$store.dispatch('setCompanyName', item.companyName);

          this.$session.set("directors", JSON.stringify(item.directors));
          this.$session.set("submissionId", item.submissionId);
          this.$session.set("companyName", item.companyName);
          this.$session.set(this.$store.state.sessionKey.SUBMISSION_VALUE, JSON.stringify(item));

          this.$router.push({ name: name, params: params});

          // if( ( this.$router.history.current.fullPath ).includes( “console” ) ) {
          //     this.$router.push({ name: ‘console-submission-detail’, params: {id: item.submissionId, email: item.email}});
          // }
          // else {
          //     this.$router.push({ name: ‘kyb-detail’, params: {id: item.submissionId, email: item.email}});
          // }
      },

      //profile에 보내줄 데이터
      showProfileModal ( item ) {
          this.currProfileModalData = item.companyProfile;
          this.showModal = true;
      },
      //  close profile modal event
      closeProfileModal() {
          this.showModal = false;
          this.currProfileModalData = {};
      },
    convertDateFormat(date){
      if(date.indexOf(' ') > -1){
        let newDate = new Date(date.split(' ')[0]).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2] + ' ' + date.split(' ')[1];
      }else{
        let newDate = new Date(date).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2];
      }
    }

  },

  mounted () {
            this.$session.remove(this.$store.state.sessionKey.SUBMISSION_VALUE);
            //this.$store.dispatch( 'callSubmissionList' );
        },

    }
</script>

<style>

    .page-item {
        margin: 0 10px !important;
        /*border: 1px solid black;*/
    }
    .page-item span, .page-item button {
        padding:7px 12px !important;
        border-radius: 10%;
    }

    .icon-area-vertical {
        line-height: 40px;
        height:40px
    }
    .progress-row {
        display:flex;
        align-items:center;
        /*height: 15px !important;*/
    }
    .card-body {
        padding: 1rem 2rem;
        font-size: 15px;
    }

    .company-name-area {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow:hidden
    }

</style>
